import { useCartContext } from '@/hooks/useCartContext';
import { Link } from 'react-router-dom';

export function CartSidebar() {
  const { items, isOpen, setIsOpen, removeFromCart, updateQuantity, subtotal, totalItems } = useCartContext();

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-white z-50 flex flex-col transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-stone-100">
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-semibold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Shopping Cart
            </h2>
            {totalItems > 0 && (
              <span className="bg-amber-500 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                {totalItems}
              </span>
            )}
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-stone-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-stone-600 text-lg" />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6">
            <div className="w-16 h-16 flex items-center justify-center bg-stone-100 rounded-full">
              <i className="ri-shopping-cart-line text-stone-400 text-2xl" />
            </div>
            <p className="text-stone-500 text-sm">Your cart is empty</p>
            <button
              onClick={() => setIsOpen(false)}
              className="text-amber-600 text-sm font-medium hover:text-amber-700 cursor-pointer"
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
              {items.map(item => (
                <div key={item.product.id} className="flex gap-4 py-4 border-b border-stone-100 last:border-0">
                  <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-stone-50">
                    <img
                      src={item.product.images[0]}
                      alt={item.product.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-stone-900 leading-tight line-clamp-2">{item.product.name}</p>
                    <p className="text-xs text-stone-400 mt-0.5">{item.product.category}</p>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center border border-stone-200 rounded-lg overflow-hidden">
                        <button
                          onClick={() => updateQuantity(item.product.id, item.quantity - 1)}
                          className="w-7 h-7 flex items-center justify-center hover:bg-stone-100 transition-colors cursor-pointer text-stone-600"
                        >
                          <i className="ri-subtract-line text-xs" />
                        </button>
                        <span className="w-8 text-center text-sm font-medium text-stone-900">{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.product.id, item.quantity + 1)}
                          className="w-7 h-7 flex items-center justify-center hover:bg-stone-100 transition-colors cursor-pointer text-stone-600"
                        >
                          <i className="ri-add-line text-xs" />
                        </button>
                      </div>
                      <span className="text-sm font-semibold text-stone-900">
                        ${(item.product.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => removeFromCart(item.product.id)}
                    className="w-6 h-6 flex items-center justify-center text-stone-300 hover:text-red-400 transition-colors cursor-pointer flex-shrink-0 mt-0.5"
                  >
                    <i className="ri-delete-bin-line text-sm" />
                  </button>
                </div>
              ))}
            </div>

            <div className="px-6 py-5 border-t border-stone-100 space-y-4">
              <div className="flex items-center justify-between text-sm text-stone-500">
                <span>Subtotal</span>
                <span className="font-medium text-stone-900">${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex items-center justify-between text-sm text-stone-500">
                <span>Shipping</span>
                <span className="text-green-600 font-medium">Free</span>
              </div>
              <div className="flex items-center justify-between font-semibold text-stone-900">
                <span>Total</span>
                <span className="text-lg">${subtotal.toFixed(2)}</span>
              </div>
              <Link
                to="/checkout"
                onClick={() => setIsOpen(false)}
                className="block w-full bg-amber-500 hover:bg-amber-600 text-white text-center py-3.5 rounded-xl font-semibold transition-colors whitespace-nowrap"
              >
                Proceed to Checkout
              </Link>
              <button
                onClick={() => setIsOpen(false)}
                className="block w-full text-center text-stone-500 hover:text-stone-700 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                Continue Shopping
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
